<template>
  <div>
    <div v-if="sortedItems.length > 0" class="">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div>
          <div
            v-if="selectable"
            :class="{ checked: allOnPageSelected() }"
            class="custom-control custom-control--checkbox mb-3"
            @click="selectAllOnPage()"
          >
            <input class="custom-control-input" type="checkbox" />
          </div>
        </div>
        <div>
          <span class="font-weight-light">{{ $t("vybrano") }}: {{ selectedRows.length }}</span>
          <span v-if="selectedRows.length !== sortedItems.length" class="link ml-4" @click="selectAll('selectAll')">
            {{ $t("vybratVse") }}
          </span>
          <span v-if="selectedRows.length > 0" class="link ml-2" @click="selectAll('deselect')">
            {{ $t("OdvybratVse") }}
          </span>
        </div>
      </div>
      <div class="row">
        <div
          v-for="(item, index) in sortedItems.slice(
            this.page * Number(this.rowsPerPage),
            this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
          )"
          :key="index"
          :class="{ 'full-width': fullWidth, 'with-kebab': kebab }"
          class="mb-3 col-md-6 col-lg-4 col-12"
        >
          <div class="layout__box justify-content-between border">
            <div class="layout__box__header justify-content-between">
              <div class="d-flex align-items-center w-100">
                <div
                  v-if="selectable"
                  :class="{
                    checked: selectedRows.filter((e) => e[itemId] === item[itemId]).length > 0
                  }"
                  class="custom-control custom-control--checkbox"
                  @click="addToSelected(item)"
                >
                  <input class="custom-control-input" type="checkbox" />
                </div>
                <h2 class="mb-0">
                  {{ item["projectName"] }}
                </h2>
              </div>
            </div>
            <div class="layout__box__content">
              <div class="dashboard__devices__row d-flex flex-wrap align-items-center justify-content-between">
                <span class="font-weight-normal" href="">
                  <span>{{ $t("CustomerId") }}</span>
                </span>
                <span class="gray-text text-extra-small">{{ item.customerId }}</span>
              </div>
              <div class="dashboard__devices__row d-flex flex-wrap align-items-center justify-content-between">
                <span class="font-weight-normal" href="">
                  <span>{{ $t("projectId") }}</span>
                </span>
                <span class="gray-text text-extra-small">{{ item.projectId }}</span>
              </div>
            </div>
            <div class="layout__box__content">
              <div v-if="item.users" class="dashboard__devices__row d-flex align-items-center justify-content-end">
                <RouterLink
                  :to="{
                    name: 'adminProjectUsers',
                    params: {
                      customerId: item.customerId,
                      projectId: item.projectId
                    }
                  }"
                  class="link-gray"
                >
                  <span>
                    <span class="text-extra-small">{{ item.users.length }}&nbsp;</span>
                    <span v-if="item.users.length == 0" class="">{{ $t("uzivatelu") }}</span>
                    <span v-else-if="item.users.length == 1" class="">{{ $t("uzivatel") }}</span>
                    <span v-else-if="item.users.length > 1 && item.users.length < 5" class="">
                      {{ $t("uzivatele") }}
                    </span>
                    <span v-else class="">{{ $t("uzivatelu") }}</span>
                  </span>
                </RouterLink>
              </div>
              <div v-if="item.services" class="dashboard__devices__row d-flex align-items-center justify-content-end">
                <RouterLink
                  :to="{
                    name: 'adminProjectServicesLimits',
                    params: {
                      customerId: item.customerId,
                      projectId: item.projectId
                    }
                  }"
                  class="link-gray"
                >
                  <span>
                    <span class="text-extra-small">{{ item.services.length }}&nbsp;</span>
                    <span v-if="item.services.length == 0" class="">{{ $t("sluzeb") }}</span>
                    <span v-if="item.services.length == 1" class="">{{ $t("sluzba") }}</span>
                    <span v-if="item.services.length > 1 && item.services.length < 5" class="">{{ $t("sluzby") }}</span>
                    <span v-if="item.services.length >= 5" class="">{{ $t("sluzeb") }}</span>
                  </span>
                </RouterLink>
              </div>
            </div>
            <div class="w-100">
              <div
                v-if="kebab && itemId"
                id="kebab"
                ref="kebab"
                :class="{ opened: openedItem[itemId] == item[itemId] }"
                class="btn btn-primary w-100"
                @click="$emit('action', item)"
              >
                {{ $t("upravit") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="sortedItems.length > 0" class="custom-table__footer d-flex align-items-center justify-content-between">
      <Paging
        :page="{
          currentPage: page,
          itemsTotalCount: sortedItems.length,
          rowsPerPage: rowsPerPage
        }"
        @next-page="page++"
        @prev-page="page--"
        @rows-per-page="rowsPerPage = $event"
      />
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import Paging from "@/components/paging/paging.vue"
import {useAuthStore} from "@/store/modules/auth";
import {useCustomerStore} from "@/store/modules/customer";

export default {
  components: { Paging },
  props: {
    columns: Array,
    items: Array,
    fullWidth: Boolean,
    kebab: Boolean,
    itemId: String,
    selectable: Boolean
  },
  setup() {
    const customerStore = useCustomerStore()
    const authStore = useAuthStore()

    return { customerStore, authStore }
  },
  data() {
    return {
      sortBy: "",
      sortType: "desc",
      sortedItems: [],
      rowsPerPage: 20,
      page: 0,
      openedItem: {},
      openedRowsSelect: false,
      selectedRows: [],
      isSelectedAllOnPage: false
    }
  },
  computed: {
    storedCustomer() {
      return this.customerStore.selectedCustomer
    },
    apiUser() {
      return this.authStore.apiUser
    }
  },
  watch: {
    rowsPerPage() {
      this.page = 0
      localStorage.rowsPerPage = this.rowsPerPage
    },
    page() {
      this.allOnPageSelected()
    },
    items() {
      this.sortedItems = [].concat(this.items)
    },
    openedItem() {
      this.openedItem[this.itemId] != undefined ? this.$emit("opened", this.openedItem) : this.$emit("opened", null)
    },
    selectedRows() {
      this.selectedRows.length > 0 ? this.$emit("selectedRows", this.selectedRows) : this.$emit("selectedRows", null)
    }
  },
  mounted() {
    if (localStorage.rowsPerPage) {
      var rows1 = localStorage.rowsPerPage
      this.rowsPerPage = rows1
    } else {
      localStorage.rowsPerPage = this.rowsPerPage
    }
    this.sortedItems = [].concat(this.items)
  },
  methods: {
    sortItemsBy(sortBy) {
      let sorted
      this.sortBy = sortBy

      let sort = new String(sortBy)
      if (this.sortType == "asc") {
        sorted = _.orderBy(this.sortedItems, `${sort}`, "desc")
        this.sortType = "desc"
      } else {
        sorted = _.orderBy(this.sortedItems, `${sort}`, "asc")
        this.sortType = "asc"
      }
      this.sortedItems = sorted
    },
    getNested(item, name) {
      let splited = name.split(".")
      if (splited.length == 1) {
        return item[name]
      } else if (splited.length == 2) {
        return item[splited[0]][splited[1]]
      } else if (splited.length == 3) {
        return item[splited[0]][splited[1]][splited[2]]
      } else if (splited.length == 4) {
        return item[splited[0]][splited[1]][splited[2]][splited[3]]
      }
    },
    openKebab(item) {
      this.openedItem = this.openedItem == item ? {} : item
    },
    addToSelected(item) {
      if (this.selectedRows.filter((e) => e[this.itemId] === item[this.itemId]).length > 0) {
        this.selectedRows = this.selectedRows.filter(e => e[this.itemId] !== item[this.itemId])
      } else {
        this.selectedRows = [...this.selectedRows, item]
      }
    },
    allOnPageSelected() {
      let itemsOnPage = this.sortedItems.slice(
        this.page * this.rowsPerPage,
        Number(this.page * this.rowsPerPage) + Number(this.rowsPerPage)
      )

      let itemsOnPageId = itemsOnPage.map((d) => d[this.itemId])
      let allItemsId = Array.from(this.selectedRows).map((d) => d[this.itemId])

      if (itemsOnPageId.every((ai) => allItemsId.includes(ai))) {
        return true
      } else {
        return false
      }
    },
    selectAllOnPage() {
      let itemsOnPage = this.sortedItems.slice(
        this.page * this.rowsPerPage,
        Number(this.page * this.rowsPerPage) + Number(this.rowsPerPage)
      )
      let itemsOnPageId = itemsOnPage.map((d) => d[this.itemId])
      let allItemsId = Array.from(this.selectedRows).map((d) => d[this.itemId])
      if (itemsOnPageId.every((ai) => allItemsId.includes(ai))) {
        let indexes = []
        itemsOnPage.forEach((element) => {
          indexes.push(Array.from(this.selectedRows).indexOf(element))
        })
        this.selectedRows.splice(indexes[0], indexes.length)
      } else {
        let indexes = []
        let same = []
        this.selectedRows.forEach((selected) => {
          let filteredArray = itemsOnPage.filter((e) => e[this.itemId] === selected[this.itemId])
          same.push(filteredArray[0])
        })
        same.forEach((element) => {
          if (element != undefined) {
            indexes.push(this.selectedRows.findIndex((obj) => obj[this.itemId] == element[this.itemId]))
          }
        })
        for (var i = indexes.length - 1; i >= 0; i--) {
          this.selectedRows.splice(indexes[i], 1)
        }
        this.selectedRows =
          this.selectedRows.length > 0
            ? this.selectedRows.concat.apply(this.selectedRows, itemsOnPage)
            : [].concat.apply([], itemsOnPage)
      }
    },
    selectAll(type) {
      if (type === "deselect") {
        this.selectedRows = []
      } else if (type === "selectAll") {
        this.selectedRows = [].concat.apply([], this.sortedItems)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
